<template>
  <path
    d="M14 8.00024C14 5.79024 12.21 4.00024 10 4.00024C7.79 4.00024 6 5.79024 6 8.00024C6 10.2102 7.79 12.0002 10 12.0002C12.21 12.0002 14 10.2102 14 8.00024ZM2 18.0002V19.0002C2 19.5502 2.45 20.0002 3 20.0002H17C17.55 20.0002 18 19.5502 18 19.0002V18.0002C18 15.3402 12.67 14.0002 10 14.0002C7.33 14.0002 2 15.3402 2 18.0002ZM18 10.0002H22C22.55 10.0002 23 10.4502 23 11.0002C23 11.5502 22.55 12.0002 22 12.0002H18C17.45 12.0002 17 11.5502 17 11.0002C17 10.4502 17.45 10.0002 18 10.0002Z"
  />
</template>
